<template>
  <v-container align-center justify-center style ="min-height: 600px; padding-top: 130px; background-color: #f0f4f0; height: 100vh; position:fixed; top:0px">

			<v-row>
				<v-col cols="12" sm="10" offset-sm="1" md="4" offset-md="4" style="padding: 12px 0;">
					<v-card style="margin: 0 15px;">
						<v-row>
							<v-col>
								<v-img src="../../../assets/logo-icoev.svg" width="280" style="margin: auto;"/>
							</v-col>
						</v-row>

						<v-card-text class="pt-4">
							<div>
								<v-form v-model="valid" ref="form">
									<v-text-field ref="username"
										label="Usuario"
										v-model="username"/>
										<v-text-field ref="password"
										label="Contraseña"
										v-model="password"
										:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
										:type="showPassword ? 'password' : 'text'"
										@click:append="() => (showPassword = !showPassword)"
										@keyup.enter="doSubmit()"/>
										<v-layout justify-space-between>
											<v-btn class="icoev-vbtn primary" @click="doSubmit()"
													:class=" { 'darken-4 white--text' : valid, disabled: !valid }"
													:loading="isLoading"
													:disabled="isLoading">
													Iniciar sesión
											</v-btn>
										</v-layout>
                    <v-checkbox 
											v-model="recallCredentials"
											:disabled="isLoading"
                      label="Recordar sesión"/>
								</v-form>
							</div>
							<div class="text-center pt-4 pb-4"> 
								<a @click="openUrl('https://www.icoev.es/solicitud-datos-rido/')" 
									style="color: #065535; font-weight: 500; text-decoration: underline;">
									¿No tienes usuario?
								</a>
							</div>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>

			<!--<v-row v-if="showSessionExpiredError" style="margin-top: 10px; margin-bottom: 0; padding: 0;">
				<v-col cols="12" style="padding: 0;">
					<v-alert type="error">
						{{ $t('app.session-expired') }}
					</v-alert>
				</v-col>
			</v-row>-->

			<!-- INICIO BLOQUE MENSAJE ESTADO PETICIONES -->
			<v-snackbar
				v-model="showAlert"
				:timeout="alertTimeout"
				:color="alertColor">
				{{ alertText }}
				<v-btn text @click="showAlert=false">
					Cerrar
				</v-btn>
			</v-snackbar>
			<!-- FIN BLOQUE ESTADO PETICIONES -->

			<v-row style="position: fixed; bottom: 0px; right: 20px">
					<span class="caption grey--text lighten-5 show-version">{{ version }}</span>
			</v-row>

	</v-container>
</template>

<script>
import api from "../../../api/icoev";
import BaseModule from '../../common/BaseModule';
import discovery from "../../../discovery";
import cordova from "../../../api/cordova";

export default {
	name: "LoginMain",
	mixins: [ BaseModule ],
	components: {},
	data() {
		return {
			valid: false,
			isLoading: false,
			showPassword: true,
			loginInfo: null,
			username: '',
			password: '',
			recallCredentials: false,
			showAlert: false,
			alertColor: 'error',
			alertText: '',
			alertTimeout: 3000,
			showSessionExpiredError: false,
			version: 'x.x.x',
		}
	},
	mounted() {
    this.$nextTick(() => {
			window.$vue.$on('set-login-info', this.checkLoginInfo);
    });

		this.$refs.username.rules.push(this.validationRules.required);
		this.$refs.password.rules.push(this.validationRules.required);
	},
	methods: {
		doShowAlert: function(payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},
		checkLoginInfo: function(info) {
			this.$log.debug("checkLoginInfo() called! [ info: " + info + " ]");

			this.recallCredentials = true;

			this.username = info.split("@")[0];
			this.password = info.split("@")[1];

			this.doLogin();
		},
		doSubmit: function() {
			if (!this.$refs.form.validate()) {
				return;
			}

			this.doLogin();
		},
		doLogin: function() {
			this.isLoading = true;

			var info = {
				username: this.username,
				password: this.password
			};

			api.login(info,
				res => {
					this.isLoading = false;

					if (!res.rsOK) {
						this.doShowAlert({ text: res.message, color: 'error', timeout: 3000 });
						return;
					}
					
					this.$store.commit('icoev/setUser', res.user);
          this.$store.commit('icoev/setRedirectToken', res.redirectToken);
					
					if (this.recallCredentials) {
						if (this.$store.state.icoev.device.platform == 'browser') {
							window.localStorage.setItem("icoev-login-info", btoa(info.username + "@" + info.password));
						} else {
							cordova.setLocalStorageItem('login-info', info.username + "@" + info.password);
						}
					} else {
						if (this.$store.state.icoev.device.platform == 'browser') {
							window.localStorage.removeItem("icoev-login-info");
						} else {
							cordova.removeLocalStorageItem('login-info');
						}
					}
			
					this.$router.push({ name: 'home' });

					setTimeout(function() {
						cordova.initializationProgress('initSession');
          }, 500);

					setTimeout(function() {
						cordova.readyToProcessNotifications();
          }, 1000);
				},
				err => {
					this.isLoading = false;
					this.$log.error(err);
					this.doShowAlert({ text: err, color: 'error', timeout: 3000 });
				}
			);
		},
		openUrl(url) {
			if (this.$store.state.icoev.device.platform == 'browser') {
				window.open(url);
				return;
			}

			cordova.openUrl(encodeURI(url));
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.username = '';
			vm.password = '';
			
			if (vm.$refs.form) {
				vm.$refs.form.resetValidation();
			}
			
			vm.$store.commit('icoev/setUser', null);
      vm.$store.commit('icoev/setRedirectToken', null);
            
			vm.recallCredentials = false;
			vm.version = discovery.version;

			cordova.initCompleted();
      cordova.setTopbarColor('black');

			if (vm.$store.state.icoev.device.platform == 'browser') {
				var info = window.localStorage.getItem("icoev-login-info");

				if (!info) {
					vm.$log.debug("Login info not found!");
					return;
				}

				vm.recallCredentials = true;
				
				vm.checkLoginInfo(atob(info));
			}
		});
	}
}
</script>

<style>
@media screen and ( max-height: 520px )
{
   .show-version {
        display: none;
    }
}

@media screen and ( min-height: 521px )
{
   .show-version {
        display: block;
    }
}
</style>